<template>
  <campaigns-list status="all" />
</template>
<script>
import CampaignsList from '@/modules/campaigns/components/CampaignsList'

export default {
  name: 'AllCampaignsTab',
  components: { CampaignsList }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/modules/campaigns/components/AllCampaignsTab.vue